import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_APPLICATIONS } from "../../../config/api";

export const getApplications = createAsyncThunk(
  "applications/get",
  async () => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_GET_APPLICATIONS,
      });

      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
    }
  }
);
